<template>
  <div
    class="sign-in-modal"
    :class="{'sign-in-modal--mobile': $isSmartphone}"
    @click="closeModal()"
  >
    <div
      class="sign-in-modal__window"
      :class="{'sign-in-modal--mobile': $isSmartphone}"
      @click.stop=""
    >
      <div class="sign-in-modal__header">
        <div class="sign-in-modal__header-left">
          <slot name="header-left" />
        </div>
        <div class="sign-in-modal__header-text">
          <slot name="header-text" />
        </div>
        <div class="sign-in-modal__header-right">
          <slot name="header-right">
            <div
              class="sign-in-modal__close-btn"
              @click="closeModal()"
            >
              <div class="sign-in-modal__close-icon">
                <span />
                <span />
              </div>
            </div>
          </slot>
        </div>
      </div>
      <div class="sign-in-modal__content">
        <slot />
      </div>
      <transition
        name="fade"
        duration="300"
      >
        <div
          v-if="loading"
          class="sign-in-modal__loading"
        >
          <Loader />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>

// import { openModalScroll, closeModalScroll } from '/src/utils/modal.js'
import { mapMutations } from 'vuex'
import Loader from '@/components/core/ui/Loader'

export default {
  name: 'ModalWrapper',
  components: {
    Loader,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
    }
  },
  methods: {
    ...mapMutations({
      closeModal: 'modals/closeModal',
    }),
  },
}
</script>

<style lang="scss">
  .sign-in-modal {
    position: fixed;
    z-index: 120;
    top: 0;
    left: 0;
    height: 100%;
    // min-height: 3.50rem;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    // justify-content: center;
    font-size: .16rem;
    line-height: .16rem;
    background: rgba(0, 0, 0, 0.5);
    overflow: hidden;
    &__window {
      position: relative;
      background: map-get($colors, 'white');
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      max-width: 4.5rem;
      border-radius: .16rem;
      margin: auto;
      overflow: hidden;
      &.sign-in-modal--mobile {
        position: fixed;
        width: 100%;
        height: 100%;
        max-width: 100vw;
        max-height: 100vh;
        // max-height: var(--app-height-without-keyboard);
        border-radius: .0rem;
        margin: 0;
      }
    }
    &__loading {
      position: absolute;
      top: 0;
      lefT: 0;

      width: 100%;
      height: 100%;

      background: map-get($colors, 'white');
      opacity: 0.94;

      display: flex;
      justify-content: center;
      align-items: center;

      color: map-get($colors, 'default');
    }
    &__header {
      position: relative;
      align-self: flex-start;
      display: flex;
      align-items: center;
      width: 100%;
      height: .56rem;
      min-height: .56rem;
      padding: 0 .16rem;
      background: map-get($colors, 'white');
      &:after {
        content: '';
        position: absolute;
        top: 100%;
        left: .16rem;
        right: .16rem;
        width: calc(100% - .32rem);
        height: 1px;
        background: #F0F0F0;
      }
      &-left {
        margin-right: auto;
        width: .24rem;
      }
      &-text {
        font-weight: normal;
        font-size: .16rem;
        line-height: .19rem;
        text-align: center;
        letter-spacing: 0.004rem;
      }
      &-right {
        margin-left: auto;
        width: .24rem;
      }
    }
    &__close {
      &-btn {
        cursor: pointer;
      }
      &-icon {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: .24rem;
        height: .24rem;
        transition: transform .3s ease-in-out;
        span {
          position: absolute;
          background: #000;
          width: 0.17rem;
          height: 0.02rem;
          border-radius: 0.02rem;
          top: 50%;
          left: 50%;
          transform: translate3d(-50%, -50%, 0);
          &:nth-child(1) {
            transform: translate3d(-50%, -50%,  0) rotate(45deg);
          }
          &:nth-child(2) {
            transform: translate3d(-50%, -50%, 0) rotate(-45deg);
          }
        }
      }
    }
    &__content {
      margin: auto;
      width: 100%;
    }
    &.sign-in-modal--mobile {
      .sign-in-modal {
        &__header {
          position: fixed;
          top: 0;
          z-index: 10;
        }
        &__content {
          position: fixed;
          top: 0;
          z-index: 1;
          height: 100%;
          padding: .56rem 0;
          overflow: scroll;
        }
      }
    }
  }

</style>
